<template>
  <div class="tags-wrapper" ref="tagsWrapper">
    <span class="el-icon-caret-left tags-btn left-btn" @click.stop.prevent="navFlip('prev')"></span>
    <div class="tags-list" ref="tagsList">
      <router-link ref='tag' class="tags-item" :to="{
          path: tag.path,
          query: tag.query
        }" :class="{'tag-active':isActive(tag)}" v-for="tag in Array.from(visitedViews)" :key="tag.path">
        <span class="el-icon-refresh refresh-btn" @click.stop.prevent="refreshSelectedTag(tag)"></span>
        <span class="text text-overflow">{{tag.meta.title}}</span>
        <span class="el-icon-close close-btn" @click.stop.prevent="closeSelectedTag(tag)"></span>
      </router-link>
    </div>
    <span class="el-icon-caret-right tags-btn right-btn" @click.stop.prevent="navFlip('next')"></span>
  </div>
</template>

<script>
export default {
  async mounted(){
    //this.addViewTags()
  },
  methods:{
    isActive(route) {
      return route.name === this.$route.name
    },
    addViewTags(){
      const { name } = this.$route
      if (name) {
        let view= this.$route
        if (view.fullPath == '/index') {
          return false
        }
        let flag = this.$store.state.tagsView.visitedViews.some(v => v.name == view.name)
        if (!flag) {
          // 父容器div的宽度
            var divOffsetWidth = this.$refs.tagsWrapper.offsetWidth - 68
            // ul的宽度
            var ulOffsetWidth = this.$refs.tagsList.offsetWidth
            // ul距离父容器的左偏移距离
            var ulTranslateX = Number(this.$refs.tagsList.style.transform.replace(/[^0-9]/gi, ''))
            // 下一页
            if (ulOffsetWidth > divOffsetWidth) {
                if (ulTranslateX + divOffsetWidth < ulOffsetWidth) {
                  var next = ulTranslateX + divOffsetWidth - 80
                  this.$refs.tagsList.style.transform = 'translateX(' + '-' + next + 'px)'
                }
              }
        }
         this.$store.dispatch('addViews', { //这要是直接传整个view过去会报栈溢出，不传matched属性过去就没事。
            path:view.path,
            query:view.query,
            name:view.name,
            fullPath:view.fullPath,
            meta:view.meta,
            params:view.params,
            hash:view.search,
        })
    }
      return false
    },
    closeSelectedTag(view) {
      if (view.fullPath == '/index') {
        return false
      }
      this.$store.dispatch('delVisitedView', view).then((views) => {
        if (this.isActive(view) ) {
          const latestView = views.slice(-1)[0]
          if (latestView) {
            this.$router.push(latestView)
          } else {
            this.$router.push('/index')
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('changeRouterAlive', false).then(() => {
        const { fullPath, path, query } = view
        this.$nextTick(() => {
          
          this.$store.dispatch('changeRouterAlive', true)
        })
      })
    },
    navFlip(type) {
      //  标签导航翻页
      /*  if(this.switchFlag){

       }*/
      // 父容器div的宽度
      var divOffsetWidth = this.$refs.tagsWrapper.offsetWidth - 68
      // ul的宽度
      var ulOffsetWidth = this.$refs.tagsList.offsetWidth
      // ul距离父容器的左偏移距离
      var ulTranslateX = Number(this.$refs.tagsList.style.transform.replace(/[^0-9]/gi, ''))
      // 上一页
      if (type == 'prev') {
        if (ulTranslateX / divOffsetWidth > 1) {
          var prev = divOffsetWidth - ulTranslateX
          this.$refs.tagsList.style.transform = 'translateX(' + prev + 'px)'
        } else {
          this.$refs.tagsList.style.transform = 'translateX(0px)'
        }
      }
      // 下一页
      if (type == 'next') {
        if (ulOffsetWidth > divOffsetWidth) {
          if (ulTranslateX + divOffsetWidth < ulOffsetWidth) {
            var next = ulTranslateX + divOffsetWidth - 80
            this.$refs.tagsList.style.transform = 'translateX(' + '-' + next + 'px)'
          }
        }
      }
    },
  },
  watch:{
    $route(){
      this.addViewTags()
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    }
  },
}
</script>

<style lang="less" scoped>
@import '../../styles/mixin.less';
.tags-wrapper{
  height: 34px;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  padding: 0 34px;
  .tags-list{
    height: 100%;
    display: flex;
    position: absolute;
    .tags-item{
      //flex: 0 0 145px;
      height: 100%;
      min-width: 145px;
      text-align: center;
      font-size: 14px;
      color: #9A9A9A;
      line-height: 34px;
      position: relative;
      border: 1px solid #DADEE2;
      box-sizing: border-box;
      padding: 0 26px;
      z-index: 0;
      &:not(:last-child){
        border-right: none;
      }
      .text{

      }
      .refresh-btn{
        display: none;
        position: absolute;
        top: 0;
        left: 10px;
        font-size: 14px;
        line-height: 34px;
        height: 100%;
        width: 16px;
      }
      .close-btn{
        position: absolute;
        height: 16px;
        width: 16px;
        border-radius: 50%;
        background: #fff;
        line-height: 16px;
        text-align: center;
        top: 9px;
        font-size: 12px;
        right: 10px;
        &:hover{
          background: #188ae2;
          color:#fff;
        }
      }
    }
    .tag-active{
      background: #108de9;
      color:#fff;
      .close-btn{
        background: #108de9;
      }
      .refresh-btn{
        display: block;
      }
    }
  }
  .tags-btn{
    position: absolute;
    height:100%;
    width: 34px;
    top: 0;
    line-height: 34px;
    color:#8e8e8e;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
    box-sizing: border-box;
  }
  .left-btn{
    left: 0;
    background: #fff;
    z-index: 1;
  }
  .right-btn{
    right: 0;
    background: #fff;
    z-index: 1;
  }
  
}
</style>
